import styled, { css } from 'styled-components';

export const StatusBoardContainer = styled.div`
  width: 95vw;
  height: 95vh;
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;

  ${(props) =>
    props.theme === 'normal' &&
    css`
      background: #262f3b;
    `}

  ${(props) =>
    props.theme === 'excel' &&
    css`
      background: #cbdbe9;
    `}
`;

export const DataTableContainer = styled.div`
  display: flex;
  height: 83vh;
  margin-bottom: 1rem;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  & > div.table-box {
    overflow-y: auto;

    & > table {
      color: #fff;
      margin: 0px;
      padding: 0.5rem;
      background: none;
      font-size: 1.5rem;

      & > thead {
        position: sticky;
        top: 0;
        & > tr {
          & > th {
            text-align: center;
            margin: 0px;
            padding: 0.5rem;
            font-size: 1rem;

            ${(props) =>
              props.theme === 'normal' &&
              css`
                background: #1f242c;
                color: #7b818a;
                border: #98989815 1px solid;
              `}

            ${(props) =>
              props.theme === 'excel' &&
              css`
                background: #ececec;
                color: #000;
                border: #000 1px solid;
              `}
          }
        }
      }
    }
  }
`;

export const EditBox = styled.div`
  display: flex;
  justify-content: flex-start;

  & > select {
    margin-right: 1rem;
  }
`;

export const GeneralInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  border: 1px solid #7b818a;

  & > div {
    display: flex;
    width: 100%;

    ${(props) =>
      props.theme === 'normal' &&
      css`
        background: #1f242c;
      `}

    ${(props) =>
      props.theme === 'excel' &&
      css`
        background: #fff;
      `}
  }

  & > div.information-title {
    border-bottom: 1px solid #7b818a;
    & > div {
      ${(props) =>
        props.theme === 'normal' &&
        css`
          background: #1f242c;
          color: #fff;
        `}
      ${(props) =>
        props.theme === 'excel' &&
        css`
          background: #ececec;
          color: #000;
        `}
    }

    & > div.module-count {
      flex: 2;
      border-right: 1px solid #7b818a;
    }
    & > div.status {
      flex: 8;
    }
  }

  & > div.information-data {
    & > div.module-count {
      flex: 2;
      border-right: 1px solid #7b818a;

      ${(props) =>
        props.theme === 'normal' &&
        css`
          background: #1f242c;
          color: #fff;
        `}

      ${(props) =>
        props.theme === 'excel' &&
        css`
          background: #ececec;
          color: #000;
        `}
    }

    & > div.status {
      flex: 2;

      &.blue {
        background: #03ab14;
        color: #fff;
      }

      &.danger {
        background: #ff0018;
        color: #fff;
      }

      &.warning {
        background: #ffae00;
        color: #fff;
      }

      &.none {
        background: #ececec;
        color: #000;
      }
    }
  }
`;

export const BoardContainer = styled.tr`
  cursor: pointer;

  ${(props) =>
    props.theme === 'excel' &&
    css`
      background: #fff;
      color: #000;
    `}

  &:hover {
    ${(props) =>
      props.theme === 'normal' &&
      css`
        background: #1f242c;
      `}

    ${(props) =>
      props.theme === 'excel' &&
      css`
        background: #ececec;
      `}
  }

  ${(props) =>
    props.status === 'danger' &&
    css`
      animation-duration: 1s;
      animation-name: dangerAnimation;
      animation-iteration-count: infinite;
    `}

  ${(props) =>
    props.status === 'warning' &&
    css`
      animation-duration: 3s;
      animation-name: warningAnimation;
      animation-iteration-count: infinite;
    `}
  
  ${(props) =>
    props.status === 'none' &&
    css`
      background: #c6c6c6;
    `}  

  @keyframes dangerAnimation {
    from {
      background: #fff;
      color: #000;
    }

    49% {
      background: #fff;
      color: #000;
    }
    50% {
      background: #ff0000;
      color: #fff;
    }

    to {
      background: #ff0000;
      color: #fff;
    }
  }

  @keyframes warningAnimation {
    from {
      background: #fff;
      color: #000;
    }

    49% {
      background: #fff;
      color: #000;
    }
    50% {
      background: #e8ad2e;
      color: #fff;
    }

    to {
      background: #e8ad2e;
      color: #fff;
    }
  }

  & > td {
    padding: 0.3rem 0;
    font-size: 1.5rem;

    ${(props) =>
      props.theme === 'normal' &&
      css`
        border: #7b818a 1px solid;
      `}

    ${(props) =>
      props.theme === 'excel' &&
      css`
        border: #000 1px solid;
      `}

    &.data-text {
      font-size: 2rem;

      & > sub {
        font-size: 1rem;
      }
    }

    & span.blue-status-text {
      color: #50bb5b;
      animation-duration: 5s;
      animation-name: blueStatusAnimation;
      animation-iteration-count: infinite;
    }

    & span.warning-status-text {
      color: #e8ad2e;
      animation-duration: 3s;
      animation-name: warningAnimationToText;
      animation-iteration-count: infinite;
    }

    & span.danger-status-text {
      color: #ff0018;
      animation-duration: 1s;
      animation-name: dangerAnimationToText;
      animation-iteration-count: infinite;
    }

    @keyframes blueStatusAnimation {
      from {
        opacity: 100;
      }
      49% {
        opacity: 100;
      }
      50% {
        opacity: 100;
      }
      51% {
        opacity: 0;
      }
      to {
        opacity: 100;
      }
    }

    & span.none-status-text {
      ${(props) =>
        props.theme === 'normal' &&
        css`
          color: #ececec;
        `}

      ${(props) =>
        props.theme === 'excel' &&
        css`
          color: #3e3e3e;
        `}
    }

    &.danger {
      ${(props) => props.status !== 'none' && 
      css`
        animation-duration: 1s;
        animation-name: dangerAnimationToText;
        animation-iteration-count: infinite;
      `}
    }

    &.warning {
      ${(props) => props.status !== 'none' && 
      css`
      animation-duration: 3s;
      animation-name: warningAnimationToText;
      animation-iteration-count: infinite;
      `}
    }

    @keyframes dangerAnimationToText {
      from {
        color: #ff0018;
      }

      49% {
        color: #ff0018;
      }
      50% {
        color: #fff;
      }

      to {
        color: #fff;
      }
    }

    @keyframes warningAnimationToText {
      from {
        color: #e8ad2e;
      }

      49% {
        color: #e8ad2e;
      }
      50% {
        color: #fff;
      }

      to {
        color: #fff;
      }
    }
  }
`;
